"use strict";

module.exports = {
    "user2": {
        "add-account": "Yeni hesap ekle",
        "edit-accounts": "Listeyi düzenle",
        "enter": "Giriş yap",
        "exit": "Çıkış",
        "help": "Yardım",
        "mail": ["yeni e-posta", "yeni e-posta", "yeni e-posta", "Yeni e-posta yok"],
        "mail_compose": "E-posta yaz",
        "passport": "Hesap yönetimi",
        "settings": "Ayarlar",
        "upload_files": "Diskim"
    }
};